export const SOUND_STORAGE_KEY = 'dice1k-sound-enabled';
export const HAPTIC_STORAGE_KEY = 'dice1k-haptics-enabled';

export const readStoredSoundPreference = (): boolean => {
  if (typeof window === 'undefined') return true;
  try {
    const raw = window.localStorage?.getItem(SOUND_STORAGE_KEY);
    if (raw === 'false') return false;
    if (raw === 'true') return true;
  } catch {
    // ignore storage failures
  }
  return true;
};

export const readStoredHapticPreference = (): boolean => {
  if (typeof window === 'undefined') return true;
  try {
    const raw = window.localStorage?.getItem(HAPTIC_STORAGE_KEY);
    if (raw === 'false') return false;
    if (raw === 'true') return true;
  } catch {
    // ignore storage failures
  }
  return true;
};
